import createJobOverview from "./ajaxJobFinder";
const jobFinderSearch = () => {
    if(document.querySelector('.ume-career-search-holder')){

       const allHolders = document.querySelectorAll('.ume-career-search-holder');
        allHolders.forEach(holder => {
            const parent = holder.closest('.ume-career-finder-holder');
            const allRadio = parent.querySelectorAll('.ume-career-super-box');


            const allNonSuper = parent.querySelectorAll('.ume-career-not-super-holder');

            const button = holder.querySelector('.ume-career-search-trigger');
            const inputField = holder.querySelector('input');
            button.addEventListener('click', ev =>{
                ev.preventDefault();

                if(button.classList.contains('ume-career-search-trigger-only-search')){

                    let url = wp_environment.home_url +'/job-finder?search='+encodeURIComponent(inputField.value);
                    window.location = url;
                    return;
                }
                allRadio.forEach(r => {
                    r.checked = false
                });
                allNonSuper.forEach(el =>{
                    el.classList.add('ume-career-initially-hidden');
                })
               // createJobOverview(document.querySelector('[data-filter-type="super"]') ? document.querySelector('[data-filter-type="super"]').getAttribute('data-filter') : '', document.querySelector('[data-filter-type="main"]') ? document.querySelector('[data-filter-type="main"]').getAttribute('data-filter') : '',  document.querySelector('[data-filter-type="sub"]') ? document.querySelector('[data-filter-type="sub"]').getAttribute('data-filter') : '', inputField.value);
                 createJobOverview( '', '',  '', inputField.value);
                // reset url without refreshing
                if(window.location.href.indexOf('job-finder') > -1){
                    window.history.pushState({}, document.title, '/job-finder/?search='+encodeURIComponent(inputField.value));
                }

            })
            inputField.addEventListener('keyup', inputFieldDebounce(() =>{
                if(!button.classList.contains('ume-career-search-trigger-only-search')){

                        if(inputField.value.length >= 3){
                            allRadio.forEach(r => {
                                r.checked = false
                            });
                            allNonSuper.forEach(el =>{
                                el.classList.add('ume-career-initially-hidden');
                            })
                            createJobOverview( '', '',  '', inputField.value);
                            // reset url without refreshing
                            if(window.location.href.indexOf('job-finder') > -1){
                                window.history.pushState({}, document.title, '/job-finder/?search='+encodeURIComponent(inputField.value));
                            }

                        }

                }
            }, 800))
            function inputFieldDebounce(callback, wait) {
                let timeout;
                return (...args) => {
                    clearTimeout(timeout);
                    timeout = setTimeout(function () { callback.apply(this, args); }, wait);
                };
            }
            document.addEventListener('keypress', ev =>{
                if(ev.key === 'Enter' && inputField == document.activeElement){
                    if(button.classList.contains('ume-career-search-trigger-only-search')){

                        let url = wp_environment.home_url +'/job-finder?search='+encodeURIComponent(inputField.value);
                        window.location = url;
                        return;
                    }
                    allRadio.forEach(r => r.checked = false);
                    allNonSuper.forEach(el =>{
                        el.classList.add('ume-career-initially-hidden');
                    })
                    createJobOverview( '', '',  '', inputField.value);
                    // set url without refreshing
                    if(window.location.href.indexOf('job-finder') > -1){
                        window.history.pushState({}, document.title, '/job-finder/?search='+encodeURIComponent(inputField.value));
                    }

                    //  createJobOverview(document.querySelector('[data-filter-type="super"]') ? document.querySelector('[data-filter-type="super"]').getAttribute('data-filter') : '', document.querySelector('[data-filter-type="main"]') ? document.querySelector('[data-filter-type="main"]').getAttribute('data-filter') : '',  document.querySelector('[data-filter-type="sub"]') ? document.querySelector('[data-filter-type="sub"]').getAttribute('data-filter') : '', inputField.value);
                }
            } )
            inputField.addEventListener('search', ev =>{
                allRadio.forEach(r => {
                    r.checked = false
                });
                allNonSuper.forEach(el =>{
                    el.classList.add('ume-career-initially-hidden');
                })
                createJobOverview('', '', '', '');
                // reset url without refreshing
                if(window.location.href.indexOf('job-finder') > -1){
                    window.history.pushState({}, document.title, '/job-finder/?search='+encodeURIComponent(inputField.value));
                }

            })
        })

    }
}
export default jobFinderSearch;